module.exports = __webpack_public_path__ + "0357fa7bf2d5cdc89d78fccf9ab3753c.jpg";